import { Popover } from '@base-ui/react/popover'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ActionPopoverTriggerProps extends PartProps<Popover.Trigger.Props> {
  className?: string
}

function ActionPopoverTrigger({ className, children, ...props }: ActionPopoverTriggerProps) {
  return (
    <Popover.Trigger
      autoFocus={false}
      className={twMerge('h-fit w-full select-none bg-transparent text-left outline-none', className)}
      render={(triggerProps) => <div {...triggerProps} />}
      nativeButton={false}
      {...props}
    >
      {children}
    </Popover.Trigger>
  )
}

export { ActionPopoverTrigger }
